import { cardClaimContext } from 'app-next/claim/card/contexts';
import { useContext } from 'react';

import { CardAttributeTypesDocument } from './CardAttributeTypes.graphql';
import type { CardAttributeType } from '.cache/__types__';

export * from './CardAttributeTypes.graphql';

import { useQuery } from '@apollo/client/react';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function useCardAttributes() {
  const { claimCardToken } = useContext(cardClaimContext);

  const { data, loading, error } = useQuery(CardAttributeTypesDocument, {
    context: claimCardToken // infer we want to use the claimCardToken when the claimCardToken is present.
      ? {
          headers: {
            authorization: `ClaimCard ${claimCardToken}`,
          },
        }
      : undefined,
  });

  return {
    cardAttributeTypes: data?.cardAttributeTypes ?? [],
    loading,
    error,
  };
}

export function useCardAttribute(attributeName: string): CardAttributeType | undefined {
  const attributes = useCardAttributes();

  return attributes.cardAttributeTypes.find((attribute) => attribute.name === attributeName);
}
